import React from "react";
import { Navbar } from "react-bootstrap";


function Footer() {
  return (
    <footer
      className="footer fixed-bottom"
    >
      <Navbar style={{ display: "flex", justifyContent: "center" }}>
        <Navbar.Brand>
          <a href="http://www.slydeveloper.com" rel="noopener noreferrer" target="_blank">
          <img
            alt="SlyDeveloper Solutions Logo"
            src="img/landing-page/SlyDeveloper_Logo.png"
            width="50"
            height="47.72"
            className="d-inline-block"
          />
          </a>
        </Navbar.Brand>
      </Navbar>
    </footer>
  );
}

export default Footer;
